import { useCallback } from 'react';

import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';

export const useDrawer: () => [boolean, (open: boolean) => void] = () => {
  const { state } = useCampaignEditorContext();
  const { dispatch } = useCampaignEditorContext();

  const setDrawerOpen = useCallback(
    (open: boolean) => {
      dispatch({ type: 'SET_DRAWER_OPEN', payload: open });
    },
    [dispatch],
  );

  return [state.drawerOpen, setDrawerOpen];
};
